import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  column-gap: 8px;
  min-height: 28px;
  padding-right: 24px;
  padding-left: 24px;
`;

export const SettingsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  column-gap: 16px;
  row-gap: 8px;
`;

export const HeaderActionsContainer = styled.div`
  flex: 0 0 auto;
  display: flex;
  column-gap: 8px;
  align-self: flex-start;
`;
